import type { Quote } from "@freightsimple/generated-dashboard-openapi-client/models/Quote";
import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";
import type { ReactNode } from "react";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";

export function shipmentRowNameForShipmentState(
  state: ShipmentState,
  selectedQuote: Quote | undefined,
  cheapestQuote: Quote | undefined,
  manualQuotingOpen: boolean,
): ReactNode {
  switch (state) {
    case ShipmentState.Quoted:
    case ShipmentState.QuoteRequested: {
      if (manualQuotingOpen) {
        return (
          <Row gap={0}>
            <div>Preparing Quotes</div>
            <div>🦸‍♀️</div>
          </Row>
        );
      } else {
        if (selectedQuote) {
          return `Quote`;
        } else if (cheapestQuote) {
          return `Quotes`;
        } else {
          return "No Quotes";
        }
      }
    }

    case ShipmentState.BookingConfirmed:
      return "Booked";
    case ShipmentState.BookingRequested:
    case ShipmentState.BookingFailed:
      return "Preparing";
    case ShipmentState.InTransit:
      return "In Transit";
    case ShipmentState.Delivered:
      return "Delivered";
    case ShipmentState.Cancelled:
      return "Cancelled";
    case ShipmentState.Lost:
      return `Lost`;
    case ShipmentState.OnHold:
      return `On Hold`;
  }
}
